var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChipImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 1.125H1.875C1.46079 1.125 1.125 1.46079 1.125 1.875V7.125C1.125 7.53921 1.46079 7.875 1.875 7.875H7.125C7.53921 7.875 7.875 7.53921 7.875 7.125V1.875C7.875 1.46079 7.53921 1.125 7.125 1.125Z",
    stroke: "#F47B25",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 4.125C3.78921 4.125 4.125 3.78921 4.125 3.375C4.125 2.96079 3.78921 2.625 3.375 2.625C2.96079 2.625 2.625 2.96079 2.625 3.375C2.625 3.78921 2.96079 4.125 3.375 4.125Z",
    stroke: "#F47B25",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 5.62489L6.71775 4.46764C6.5771 4.32703 6.38637 4.24805 6.1875 4.24805C5.98863 4.24805 5.7979 4.32703 5.65725 4.46764L2.25 7.87489",
    stroke: "#F47B25",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipImage);
export default __webpack_public_path__ + "static/media/chip-image.bc05686f5bef13001018b9f776e3e4fa.svg";
export { ForwardRef as ReactComponent };